import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { InvoiceTaskFileEditForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskFileEditForm';
import { useParams } from 'react-router-dom';

export const BackofficeInvoiceTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { sales_order_id } = useParams();
  const { invoiceTask: task } = useCurrentInvoiceTask();
  useEffect(() => setTitle(`請求書等ファイル一覧`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `請求タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/invoice_tasks` },
        {
          label: `請求タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${sales_order_id}/invoice_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <InvoiceTaskFileEditForm />
    </WorkspaceLayout>
  );
};
